/**********************************************************************************************************
 *   BASE IMPORT
 **********************************************************************************************************/
import React, { useState } from 'react'
import { reduxForm, Field } from 'redux-form'
import { useSelector, useDispatch } from 'react-redux'

/**********************************************************************************************************
 *   UTILTIY FUNCTIONS
 **********************************************************************************************************/
import ACCOUNT_API from '../../../utilities/api/account'
import {
    getDataFromSuccessResponse,
    getErrorFromFailResponse
} from '../../../utilities/function/apiResponse'
import {
    requiredFieldValidation,
    emailFieldValidation
} from '../../shared/form/validation'

import { updatePopupNotification } from '../../../app/action'
import { getAppConfigValue } from "../../../utilities/function/configuration"

/**********************************************************************************************************
 *   SHARED
 **********************************************************************************************************/
import Loading from '../../../components/shared/loading'
import TextField from '../../shared/form/textfield'

import feedback from "../../../utilities/images/feedback-red.svg"




/**********************************************************************************************************
 *   FORM START
 **********************************************************************************************************/
let FeedbackForm = (props) => {
    let { onSubmit, handleSubmit, userDetails } = props
    const { email, firstname, lastname } = userDetails || {}
    return (
        <form className={`of-finished-feedback-form`} onSubmit={handleSubmit(onSubmit)} >
            <Field label={'Name'} name={'name'} component={TextField} placeholder={'Name'} input={{ disabled: true, value: `${firstname} ${lastname}` }} />
            <Field label={'Email Address'} name={'email'} component={TextField} placeholder={'Email Address'} validate={[emailFieldValidation]} input={{ disabled: true, value: email }} />
            <Field label={'Feedback'} rows="8" name={'message'} component={TextField} validate={[requiredFieldValidation]} placeholder={'Feedback'} autoFocus={true} />
            <button type='submit' className={`of-solid-button of-select-button of-select-domain__button primary-background-1-100`}>Submit Feedback</button>
        </form>
    )
}

FeedbackForm = reduxForm({
    form: 'FeedbackForm '
})(FeedbackForm)


/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
const Feedback = (props) => {
    const dispatch = useDispatch()
    const { requestUser } = props

    const scores = ['Terrible', 'Bad', 'Okay', 'Good', 'Excellent'];
    const { finished } = useSelector(state => ({ finished: state.app.finished }))
    const [score, setScore] = useState(0);
    const [showFeedbackLightbox, setShowFeedbackLighbox] = useState(false)
    const [starsClicked, setStarsClicked] = useState(false)
    const [leaveFeedbackStatus, setLeaveFeedbackStatus] = useState({})

    if (!getAppConfigValue('feedback_enabled')) {
        return <></>
    }

    /******** Functions ********/

    // Rest Feedback States
    const resetScore = () => {
        setStarsClicked(false)
        setScore(0)
        setShowFeedbackLighbox(false)
    }


    let feedbackSuccess = leaveFeedbackStatus && leaveFeedbackStatus.status !== 'success'
    // Star Actions
    const starMouseOver = (e, i) => {
        if (feedbackSuccess) {
            setScore(i + 1)
        }
    }
    const starMouseLeave = () => {
        if (feedbackSuccess && !starsClicked) {
            setScore(0)
        }
    }
    const starClicked = (e, i) => {
        if (feedbackSuccess) {
            setStarsClicked(true);
            if (i + 1 < 4) {
                setShowFeedbackLighbox('private-feedback')
            } else {
                setShowFeedbackLighbox('public-feedback')
            }
        }
    }

    // Internal Feedback Form Submission
    const feedbackSubmit = (values) => {
        setLeaveFeedbackStatus({
            status: 'loading',
            data: {}
        })
        const msg = `Rating: ${scores[score - 1]}
    ${values.message}`
        let att = {
            department: "feedback",
            is_existing_service: false,
            subject: "General Feedback | Source: Checkout Area",
            message: msg
        }
        ACCOUNT_API.leaveFeedback(att).then(successresponse => {
            const data = getDataFromSuccessResponse(successresponse)
            setLeaveFeedbackStatus({
                status: 'success',
                data
            })
        }, errorresponse => {
            const error = getErrorFromFailResponse(errorresponse)
            const newPopupNotification = {
                status: 'error',
                error,
                data: null
            }
            updatePopupNotification(dispatch, newPopupNotification)
            setLeaveFeedbackStatus({
                status: 'error',
                error
            })
            resetScore();
        })

    }


    // External Review Platforms with Optional Links || Overides in Wordpress Plguin Configuration
    const feedbackPlatforms = [{
        logo: 'https://ventraip.com.au/wp-content/uploads/2020/04/facebook.svg',
        logoStyle: '--facebook',
        link: getAppConfigValue('feedback_link_facebook') ?
            getAppConfigValue('feedback_link_facebook') :
            'https://www.facebook.com/pg/ventraip/reviews/'
    },
    {
        logo: 'https://ventraip.com.au/wp-content/uploads/2021/03/google-business-logo.png',
        logoStyle: '--google',
        link: getAppConfigValue('feedback_link_google') ?
            getAppConfigValue('feedback_link_google') :
            'http://search.google.com/local/writereview?placeid=ChIJ-0bk9f8Z1moR06OBA3KnOw8'
    },
    {
        logo: 'https://ventraip.com.au/wp-content/uploads/2021/03/pr-logo.svg',
        logoStyle: '--productreview',
        link: getAppConfigValue('feedback_link_productreview') ?
            getAppConfigValue('feedback_link_productreview') :
            'https://www.productreview.com.au/listings/ventraip-australia/write-review'
    }]


    /********* Renders *********/

    // Feedback Lightbox Render ** Including popup window
    const renderFeedbackLightbox = () => {
        if (!showFeedbackLightbox) { return <></> }

        return (
            <div className={`of-finished-feedback-lightbox`}>
                <div className={`of-finished-feedback-popup`}>
                    <div className={`of-finished-feedback-popup__action-wrapper`}>
                        <div onClick={
                            () => {
                                if (leaveFeedbackStatus && leaveFeedbackStatus.status === 'success') {
                                    setShowFeedbackLighbox(false)
                                } else {
                                    resetScore()
                                }
                            }} className={`of-finished-feedback-popup__action icon-of-blog-close`}></div>
                    </div>
                    <div className={`of-finished-feedback-popup__content`}>
                        {showFeedbackLightbox === 'private-feedback' && <>

                            {/* Leave Feedback Internally - Form with submission */}
                            {(leaveFeedbackStatus && !leaveFeedbackStatus.status) && <>
                                <div className={`of-finished-feedback-popup__heading text-font-1-100`}>
                                    Sorry to hear you haven’t had the great
                                <br />
                                experience we pride ourselves on!
                            </div>
                                <div className={`of-finished-feedback-popup__subheading text-font-1-100`}>
                                    We would love to resolve the issue so please tell us exactly what happened and we’ll be in touch.
                            </div>
                                {(requestUser.status === 'success' && requestUser.data && requestUser.data.attributes && finished) &&
                                    <FeedbackForm
                                        userDetails={requestUser.data.attributes}
                                        onSubmit={feedbackSubmit} />
                                }
                            </>}

                            {/* Leave Feedback Internally - Thank you Success */}
                            {leaveFeedbackStatus && leaveFeedbackStatus.status === 'success' && <>
                                <div className={`of-finished-feedback-popup__center`}>
                                    <div className={`of-finished-feedback-popup__tick status-background-1-100`}>
                                        <i className="of-checkout-header__heading-icon icon-of-tick-solid"></i>
                                    </div>
                                    <div className={`of-finished-feedback-popup__heading text-font-1-100`}>
                                        Your feedback has been submitted.
                                    </div>
                                    <div className={`of-finished-feedback-popup__subheading text-font-1-100`}>
                                        Thank you for taking the time to provide feedback. Our customer care team will review
                                        your submission and take the necessary steps to help make your next experience a positive one.
                                    </div>
                                    <button type='button' onClick={() => { setShowFeedbackLighbox(false) }} className={`of-solid-button of-select-button of-select-domain__button primary-background-1-100`}>Close</button>
                                </div>
                            </>}

                            {(leaveFeedbackStatus && leaveFeedbackStatus.status === 'loading') && <>
                                <div className={`of-finished-feedback-popup__center of-finished-feedback-popup__loading`}>
                                    <Loading className={'of-checkout-user-details__loading-wrapper'} />
                                </div>
                            </>}

                        </>}
                        {/* Leave Feedback Externally */}
                        {showFeedbackLightbox === 'public-feedback' && <>
                            <div className={`of-finished-feedback-popup__heading text-font-1-100`}>
                                We're happy to hear that your experience with
                                <br />
                                VentraIP Australia was positive!
                            </div>
                            <div className={`of-finished-feedback-popup__subheading text-font-1-100`}>
                                To help us spread the word that there’s a better local alternative to the bigger overseas providers,
                                we would appreciate a few minutes of your time to leave us a review on your preferred review site.
                            </div>
                            <div className={`of-finished-feedback-platforms-wrapper`}>
                                {Object.keys(feedbackPlatforms).map(i => renderFeedbackPlatform(i, feedbackPlatforms[i]))}
                            </div>
                        </>}
                    </div>
                </div>
            </div>
        )
    }

    // External Review Platform Render - Leave Feedback (eg. Google, Facebook)
    const renderFeedbackPlatform = (index, platform) => {
        return (
            <div key={index} className={`of-finished-feedback-platform`}>
                <div className={`of-finished-feedback-platform__image-wrapper`}>
                    <img className={`of-finished-feedback-platform__image of-finished-feedback-platform__image${platform.logoStyle}`} src={platform.logo} alt={platform.logoStyle} />
                </div>
                <a href={platform.link}
                    target='_blank'
                    rel="noopener noreferrer"
                    onClick={() => {
                        setLeaveFeedbackStatus({
                            status: 'success',
                            data: {}
                        });
                        setShowFeedbackLighbox(false);
                    }
                    }
                    className={`of-finished-feedback-platform__button primary-border-1-100 primary-font-1-100`}> Leave a review </a>
            </div>
        )
    }

    // Star Render
    const renderFeedbackStars = () => {
        const isFilled = (index) => index > score
        const stars = scores.map((index, i) => <span key={i}
            onMouseOver={(e) => starMouseOver(e, i)}
            onMouseLeave={(e) => starMouseLeave()}
            onClick={e => starClicked(e, i)}
            className={`of-finished-feedback__stars-item ${leaveFeedbackStatus && leaveFeedbackStatus.status === 'success' ? 'of-finished-feedback__stars-item--done' : ''} icon-of-star-${isFilled(i + 1) ? 'outline' : 'filled'}`}></span>
        );

        return (
            <div className={`of-finished-feedback__stars-wrapper`}>
                <div className={`of-finished-feedback__stars`}> {stars} </div>
                <span className={`of-finished-feedback__stars-label`}>
                    {scores[score - 1] ? scores[score - 1] : 'Click to rate'}
                </span>
            </div>
        )
    }

    // Main Component Render - Return
    return (
        <>
            <div className={`of-finished-feedback primary-background-2-100`}>
                <img className={`of-finished-feedback__icon`} src={feedback} alt="Feedback icon" />
                <div className={`of-finished-feedback__title text-font-1-100`}>
                    {`How happy are you with`}<br />{`VentraIP Australia's service?`}
                </div>
                {renderFeedbackStars()}
            </div>
            {renderFeedbackLightbox()}
        </>
    )
}

export default Feedback